import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import AddAKModal from "../Modals/AddAKModal";

export default function AccessKeysTable() {
  const [accessKeys, setAccessKeys] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(true);

  const columns = [
    {
      field: "keyName",
      headerName: "Key name",
      minWidth: 150,
      flex: 3,
    },
    {
      field: "value",
      headerName: "Value",
      minWidth: 400,
      flex: 5,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 4,
    }
  ];

  React.useEffect(() => {
    axios
      .get(`/access_keys`)
      .then((res) => {
        setAccessKeys(res.data.accessKeys);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, [refresh]);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div id="m" style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          
          alignItems: "flex-end"
          }}>
        <Box sx={{ height: 660
          , width: "100%"
          

         }}>
          
          <DataGrid
            loading={isLoading}
            getRowId={(row)=> row.internalId}
            rows={accessKeys.map((accessKey, index)=>{
              accessKey.internalId = index;
              return accessKey
            })}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              sorting: {
                sortModel: [{ field: 'id', sort: 'desc' }],
              },
            }}
          />
          
        </Box>
        <AddAKModal accessKeys={accessKeys} setAccessKeys={setAccessKeys} refresh={refresh} setRefresh={setRefresh} setErr={setErr}/>
        </div>
      )}
    </React.Fragment>
  );
}
